import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import ServicesSection from "./components/ServicesSection";
import CaseStudy from "./components/CaseStudy";
import ContactForm from "./components/FinalCTA";
import Footer from "./components/Footer";
import BookCall from "./pages/BookCall";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import AboutPage from "./pages/AboutPage";
import SolutionsPage from "./pages/SolutionsPage";
import AppStudioPage from "./pages/AppStudioPage";

function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <ServicesSection />
      <CaseStudy />
      <ContactForm />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/book-call" element={<BookCall />} />
        <Route path="/case-studies" element={<CaseStudiesPage />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/app-studio" element={<AppStudioPage />} />
      </Routes>
    </Router>
  );
}

export default App;
